import { render } from "./InputsInformationsItem.vue?vue&type=template&id=6048acb2"
import script from "./InputsInformationsItem.vue?vue&type=script&lang=js"
export * from "./InputsInformationsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__